import React from 'react';
import PropTypes from 'prop-types';
import { Image, Link } from 'components';

const SectionThreeCol = ({
  enabled,
  title,
  colOneImg,
  colOneTitle,
  colOneText,
  colTwoImg,
  colTwoTitle,
  colTwoText,
  colThreeImg,
  colThreeTitle,
  colThreeText,
  buttonUrl,
  buttonText
}) => {
  if(!enabled) return false;
  return (
    <div className='section-reasons fvw'>
      <div className='content-wrapper'>
        <h3 className='section-title mb-50' dangerouslySetInnerHTML={{__html: title}}></h3>
        <div className='section-icons'>
          <div className='icon-wrapper'>
            <Image url={colOneImg} alt={colOneTitle} />
            <h4>{colOneTitle}</h4>
            <p>{colOneText}</p>
          </div>
          <div className='icon-wrapper'>
            <Image url={colTwoImg} alt={colTwoTitle} />
            <h4>{colTwoTitle}</h4>
            <p>{colTwoText}</p>
          </div>
          <div className='icon-wrapper'>
            <Image url={colThreeImg} alt={colThreeTitle} />
            <h4>{colThreeTitle}</h4>
            <p>{colThreeText}</p>
          </div>
        </div>
        <div className='flex-center mt-50'>
          <Link to={buttonUrl} className='button ghost'>{buttonText}</Link>
        </div>
      </div>
    </div>
  );
};

SectionThreeCol.propTypes = {
    enabled: PropTypes.bool,
    title: PropTypes.string,
    colOneImg: PropTypes.string,
    colOneTitle: PropTypes.string,
    colOneText: PropTypes.string,
    colTwoImg: PropTypes.string,
    colTwoTitle: PropTypes.string,
    colTwoText: PropTypes.string,
    colThreeImg: PropTypes.string,
    colThreeTitle: PropTypes.string,
    colThreeText: PropTypes.string,
    buttonUrl: PropTypes.string,
    buttonText: PropTypes.string
};

export default SectionThreeCol;
